import { TFunction } from 'next-i18next';
import {
  BackendItems,
  BlockchainItems,
  DigitalDesignItems,
  FrontendItems,
  InfrastructureItems,
  MobileItems,
  ReportAndCommunicationItems,
  TestingQAItems,
} from './tools';

export enum TECH_STACK_ENUM {
  DIGITAL_DESIGN = 'digital-design',
  FRONT_END = 'front-end',
  BACK_END = 'back-end',
  MOBILE = 'mobile',
  BLOCKCHAIN = 'blockchain',
  INFRASTRUCTURE = 'infrastructure',
  TESTING_QA = 'testing-qa',
  REPORT_AND_COMMUNICATION = 'report-and-communication',
}

export interface Stack {
  url: string;
  alt: string;
}

export const itemITStaffAugmentationBreadcrumbs = (t: TFunction) => [
  {
    name: t('common.home'),
    path: '/',
  },
  {
    name: t('common.services'),
    path: '/services',
  },
  {
    name: t('service.it_staff_augmentation_services'),
    path: '/services/dedicated-development-team',
  },
];

export const expertsItems = [
  {
    title: 'service.10_pm',
    description: 'service.to_oversee_the_planning',
    icon: '/icons/services/devops-engineer-icon.svg',
  },
  {
    title: 'service.10_uxui_designers',
    description: 'service.to_take_your_software',
    icon: '/icons/services/ux.ui-designers-icon.svg',
  },
  {
    title: 'service.40_fe',
    description: 'service.to_turn_wireframes',
    icon: '/icons/services/frontend-developers-icon.svg',
  },
  {
    title: 'service.40_be',
    description: 'service.to_strengthen',
    icon: '/icons/services/backend-developers-icon.svg',
  },
  {
    title: 'service.20_devops',
    description: 'service.to_ensure_what',
    icon: '/icons/services/devops-icon.svg',
  },
  {
    title: 'service.30_qa',
    description: 'service.to_accompany_the_development',
    icon: '/icons/services/qa-speciallists-icon.svg',
  },
];

export const effectivelyItems = (t: TFunction) => [
  {
    title: t('service.any_position_filfilled'),
    describe: t('service.as_a_full_cycle_development'),
  },
  {
    title: t('service.expertise_honed_by_exp'),
    describe: t('service.80_of_our_staff'),
  },
  {
    title: t('service.every_opportunity'),
    describe: t('service.dont_let_one_gap_slow_down'),
  },
  {
    title: t('service.management_however'),
    describe: t('service.choose_to_have_full_control'),
  },
  {
    title: t('service.time_and_cost'),
    describe: t('service.no_more_headaches_over_overhead'),
  },
];

export const ourITStaffAugmentationProcess = (t: TFunction) => [
  {
    title: t('service.discovery'),
    content: t('service.wo_get_to_know'),
  },
  {
    title: t('service.talent_matching'),
    content: t('service.we_assess_your_request'),
  },
  {
    title: t('service.onboarding'),
    content: t('service.our_augmented_staff'),
  },
  {
    title: t('service.collaboration'),
    content: t('service.the_augmented_development'),
  },
  {
    title: t('service.final_delivery'),
    content: t('service.we_finish_all_required'),
  },
];

export const takeCareItems = [
  {
    title: 'dedicated_development.what_you_do',
    descriptionList: [
      'service.define_requirements',
      'service.provide_our_staff',
      'service.actively_manage',
      'service.review_and_approve',
    ],
    icon: '/icons/check-icon-version1.svg',
  },
  {
    title: 'dedicated_development.what_we_do',
    descriptionList: [
      'service.provide_talents_that_exclusively',
      'service.strictly_follow',
      'service.comply_with_all_pm',
      'service.continously_transfer_expertise',
      'service.provide_further_support',
    ],
    icon: '/icons/check-icon-version2.svg',
  },
];

export const recognizedItems = (t: TFunction) => [
  {
    image: '/images/about/ISO-27001-2013.webp',
    alt: 'Certified Company - ISO[27001:2013]',
    content: t('about-us.txtISO'),
    link: '',
  },
  {
    image: '/images/about/ISO-9001-20150.webp',
    alt: 'Certified Company - ISO[9001:2015]',
    content: t('about-us.iso_9001'),
    link: '',
  },
  {
    image: '/images/about/top-b2b-companies.webp',
    alt: t('about-us.txtB2b'),
    content: t('home.txtClutchLogo'),
    link: '',
  },
  {
    image: '/images/about/app-futa.webp',
    alt: t('about-us.txtB2b'),
    content: t('common.txtAppfutas'),
    link: '',
  },
  {
    image: '/images/about/goodfirm-award.webp',
    alt: 'Goodfirm awards',
    content: t('common.txtBestGood'),
    link: 'https://www.goodfirms.co/company/ekotek',
  },
  {
    image: '/images/about/logo-bronze.webp',
    alt: 'Token Vesting Portal Fintech Solution',
    content: t('home.txtStevieLogo'),
    link: '',
  },
  {
    image: '/images/about/logo-top-blockchain.webp',
    alt: t('about-us.txtTopBlockChain'),
    content: t('home.txtGoodFirmLogo'),
    link: 'https://www.goodfirms.co/company/ekotek',
  },
  {
    image: '/images/about/logo-software.webp',
    alt: 'software developers vietnam',
    content: t('home.txtSofwareLogo'),
    link: '',
  },
  {
    image: '/images/about/top-b2b-services.webp',
    alt: t('about-us.txtB2b'),
    content: t('home.txtClutchLogo'),
    link: '',
  },
  {
    image: '/images/about/logo-bga.webp',
    alt: t('about-us.txtJAB'),
    content: t('home.txtBGALogo'),
    link: '',
  },
  {
    image: '/images/about/logo-tech-review.webp',
    alt: 'Techreviewer',
    content: t('home.txtTechReviewLogo'),
    link: '',
  },
  {
    image: '/images/about/top-mobile-app.webp',
    alt: t('about-us.txtTopMobile'),
    content: t('home.txtGoodFirmLogo'),
    link: 'https://www.goodfirms.co/company/ekotek',
  },
];

export const techStackItems = [
  {
    label: 'dedicated_development.digital_design',
    key: TECH_STACK_ENUM.DIGITAL_DESIGN,
    children: DigitalDesignItems,
  },
  {
    label: 'dedicated_development.frontend',
    key: TECH_STACK_ENUM.FRONT_END,
    children: FrontendItems,
  },
  {
    label: 'dedicated_development.backend',
    key: TECH_STACK_ENUM.BACK_END,
    children: BackendItems,
  },
  {
    label: 'dedicated_development.mobile',
    key: TECH_STACK_ENUM.MOBILE,
    children: MobileItems,
  },
  {
    label: 'dedicated_development.blockchain',
    key: TECH_STACK_ENUM.BLOCKCHAIN,
    children: BlockchainItems,
  },
  {
    label: 'dedicated_development.infrastructure',
    key: TECH_STACK_ENUM.INFRASTRUCTURE,
    children: InfrastructureItems,
  },
  {
    label: 'dedicated_development.testing_qa',
    key: TECH_STACK_ENUM.TESTING_QA,
    children: TestingQAItems,
  },
  {
    label: 'dedicated_development.report_communication',
    key: TECH_STACK_ENUM.REPORT_AND_COMMUNICATION,
    children: ReportAndCommunicationItems,
  },
];

export const faqITStaffAugmentation = (t: TFunction) => [
  {
    question: t('service.what_is_staff_augmentation'),
    answer: t('service.staff_augmentation_is'),
  },
  {
    question: t('service.how_is_staff_augmentation'),
    answer: t('service.different_from_dedicated_teams'),
  },
  {
    question: t('service.when_is_staff_augmentation'),
    answer: t('service.right_choice_for_companies'),
  },
  {
    question: t('service.what_are_the_advantages'),
    answer: t('service.a_cost_effective_method'),
  },
  {
    question: t('service.what_is_the_cost'),
    answer: t('service.cost_of_staff_augmentation'),
  },
];
